module.exports = __webpack_public_path__ + "assets/img/service_numerisation_documents.9b23029e.jpg";